export const isValidISODateTime = (dateTime) => {
    const isoDateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
    return isoDateTimeRegex.test(dateTime);
};

export const handleDateTimeFormat = ({ dateTime, normal, iso }) => {
    if (iso) {
        const [date, time, period] = dateTime.split(" ");
        const [day, month, year] = date.split("-");
        let [hours, minutes] = time.split(":");

        if (period === "PM" && parseInt(hours, 10) !== 12) {
            hours = parseInt(hours, 10) + 12;
        } else if (period === "AM" && parseInt(hours, 10) === 12) {
            hours = "00";
        }

        const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
        return formattedDateTime;

    } else if (normal) {
        const date = new Date(dateTime);

        // Extract the year, month, day, hours, and minutes
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = "00"; // Set seconds to "00"

        const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return formattedDateTime;
    }
};